export default __webpack_public_path__ + "static/NJSOMA 2024 1(2) 66 to 69-b74690a83a2ee9e5528b0340d94a136f.pdf";